import React,{Component} from 'react';
import Button from '@material-ui/core/Button';
import {history} from '../../../shared/configure-store';
import {connect} from 'react-redux';
import {RootActions} from '../../../shared/root-action';
import Logo from '../../../images/logo-black.png';
import Copyright from '../../presentational/copyright';
import {toast, ToastContainer} from 'react-toastify';
import {bindActionCreators} from 'redux';
import QRCode from 'qrcode.react';
import Api from '../../../libraries/api';
import ReactToPrint from 'react-to-print';
import _ from "lodash";
import language from "../../../libraries/label-lang";

require('dotenv').config();

class ReservationSuccess extends Component {
    constructor(props) {

        super(props);

        this.state = {
            loading: false,
            email: '',
            labels: [],
        };
    }

    componentDidMount() {
        document.title = 'Fresh Factory - Berhasil';

        this.setState({
            loading: true,
        });

        let params = {
            reservationId: this.props.match.params.id,
        };

        Api.post('/reservation/label',params).then(resp => {

            let dataLababels = [];
            let item = [];
            if (resp.data.length > 0) {
                _.forEach(resp.data, function(v, i){
                   let row = i+1;
                   // console.log(row)

                   let mod = row%3;
                    if(mod === 1) {
                        item = [];
                    }
                    // console.log(mod)
                    item.push(v);
                    if(mod === 1) {
                        dataLababels.push(item);
                    }/*else if(mod === 1) {
                        dataLababels.push(item);
                    }*/
                });

                this.setState({
                    labels: dataLababels,
                    loading: false,
                });
            }
        }).catch(err => {
            this.setState({
                loading: false,
            });
            this.showMessage(false, err.message);
        });
    }

    showMessage = (status, message) => {
        if(status) {
            toast.success(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }else {
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }
    };

    handleGo  = (link) => {

        history.push(link);
    };


    render() {

        let lang = {};
        if(this.props.toggle_set_lang === 'indo') {
            lang = language.id;
        }else {
            lang = language.en;
        }
        const text = lang;

        return (
            <main className='success'>
                <section className='my-auto'>
                    <div className='container text-center'>
                        <div className='row justify-content-center'>
                            <div className='col-md-10 col-lg-8 text-center'>
                                <img src={Logo} alt='logo' className='img-logo' />
                                <div className='steps'>
                                    <p className=' mb-0'><b>{text.reservation_step} 3</b></p>
                                    <p className='p-18 mb-0'><b>{text.reservation_step3_text}</b></p>
                                </div>
                            </div>
                        </div>

                        <div className='row'>
                            {this.state.loading ? (
                                <div className='col-12'>
                                    <i className='fa fa-spinner fa-spin'>&nbsp; </i>
                                </div>
                            ) : (
                                this.state.labels.length === 0 ? (
                                    <div className='col-12'>
                                        <p>{text.label_no}</p>
                                    </div>
                                ) : (
                                    <PrintLabels data={this.state.labels } ref={el => (this.componentRef = el)} />
                                )
                            )}
                        </div>

                        <div className='mt-4 button-small'>
                            <ReactToPrint
                                trigger={() =>  <Button
                                    variant='contained'
                                    color='primary'
                                    className='mr-3'
                                    disabled={this.state.labels.length === 0}
                                >Print</Button>}
                                content={() => this.componentRef}
                            />
                            <Button
                                variant='contained'
                                className='btn-link mr-3'
                                disabled={this.state.labels.length === 0}
                                onClick={() => this.handleGo('/reservation-note/'+this.props.match.params.id)}
                            >
                                {text.button_next}
                            </Button>
                        </div>
                    </div>
                </section>
                <footer>
                    <p className='text-center absolute-bottom'><Copyright /></p>
                </footer>
                <ToastContainer autoClose={false} />
            </main>
        );
    }
}

class PrintLabels extends Component {
    constructor(props) {

        super(props);

        this.state = {
            loading: false,
            email: '',
            labels: this.props.data,
        };
        // console.log(this.props.data)
    }

    componentDidMount() {
        document.title = 'Fresh Factory - Berhasil';

    }

    render() {

        return (
            <table width="100%">
                <thead>
                    <tr>
                        <th></th>
                        <th></th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        this.state.labels.length > 0 &&
                        this.state.labels.map((row, idx) => {
                            return (
                                <tr key={idx}>
                                    {
                                        row.map(item => {
                                            return (
                                                <td key={item.ikuId} width="33%">
                                                    <div className='card card-label'>
                                                        <QRCode
                                                            size={75}
                                                            value={item.ikuId}/>
                                                        <div className='label-content'>
                                                            <h4 className='mb-1'>IKU: {item.ikuId}</h4>
                                                            <p><strong>{item.skuNumber} - {item.productName}</strong></p>
                                                            <p>Locker: {item.locker}</p>
                                                        </div>
                                                    </div>
                                                </td>
                                            );
                                        })
                                    }
                                </tr>
                            );
                        })
                    }
                </tbody>
            </table>
        )
    }
}


const mapStateToProps = (state) => {

    return {

        profile_state: state.profile_state,

        toggle_set_lang: state.toggle_set_lang,
    };

};

const mapDispatchToProps = (dispatch) => {

    return bindActionCreators(RootActions, dispatch)

};

export default connect(mapStateToProps, mapDispatchToProps)(ReservationSuccess);